import {GET, POST} from '../index'

export const getCityList = (data) => {
  return GET('/city/list', data)
}

export const updateCity = (data) => {
  return POST('/city/update', data)
}

export const delCity = (id) => {
  return POST(`/city/${id}/destroy`)
}

export const createCity = (data) => {
  return POST('/city/store', data)
}



// WEBPACK FOOTER //
// ./src/api/city/index.js